import PriceFinderLayout from './PriceFinderLayout';

export default PriceFinderLayout;
